// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2h5FE","range":"MonthRangeSwitch_range__HD2oT","disabled":"MonthRangeSwitch_disabled__1pBlY"};